/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.08.17.
 */

import React from "react";
import ReactDOM from "react-dom";
import Confirmation from "../components/Confirmation";

function ModalUserConfirmation(holderID) {
    var modalHolder = document.getElementById(holderID);

    return function (message, callback) {
        let confirmationCallback = function (result) {
            // Unmount confirmation dialog:
            ReactDOM.unmountComponentAtNode(modalHolder);
            return callback(result);
        };

        ReactDOM.render((
            <Confirmation onClick={confirmationCallback} message={message} />
        ), modalHolder);
    };
}

export {
    ModalUserConfirmation
};
